export default __webpack_public_path__ + "static/media/t34.f277211a.jpg";